<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoOff_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1.417 1.661a.5.5 0 0 0-.707.707l1.723 1.723A1.995 1.995 0 0 0 1 6v4a2 2 0 0 0 2 2h7c.09 0 .177-.014.264-.028l.042-.007 2.815 2.815a.5.5 0 0 0 .707-.707L1.417 1.661ZM12 10V6a2 2 0 0 0-2-2H5.17l6.698 6.698c.081-.218.132-.451.132-.698Zm1-3.5 2.18-1.817a.5.5 0 0 1 .82.385v5.865a.5.5 0 0 1-.82.384L13 9.5v-3Z"
        clip-rule="evenodd"
    />
</svg>
